"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _mobileContent = _interopRequireDefault(require("./mobileContent"));
var _creatApp = require("@/api/creatApp");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    MobileContent: _mobileContent.default
  },
  props: {
    appId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      activeNum: 1,
      tableData: [{
        name: '客服图标',
        size: '180*180',
        type: 'customerServiceIcon',
        url: '',
        text: '客服'
      }, {
        name: '客服弹窗',
        size: '500*600',
        url: ''
      }, {
        name: '消息图标',
        size: '180*180',
        type: 'msgIcon',
        url: '',
        text: '消息'
      }, {
        name: '转链图标',
        size: '180*180',
        type: 'turnIcon',
        url: '',
        text: '转链'
      }, {
        name: '文字色值',
        size: '',
        type: 'textColor',
        color: ''
      }, {
        name: '首页背景',
        size: '180*180',
        type: 'bg',
        url: ''
      }],
      tableDataTwo: [{
        name: '首页顶部轮播',
        isShow: 1,
        type: 'banner'
      }, {
        name: '首页顶部小轮播',
        isShow: 1,
        type: 'smallBanner'
      }, {
        name: '金刚区',
        isShow: 1,
        type: 'diamond'
      }, {
        name: '头条信息',
        isShow: 1,
        type: 'headMsg'
      }],
      tableDataThree: [{
        name: '4连块',
        isShow: 1,
        type: 'fourBatch'
      }, {
        name: '首页中部轮播',
        isShow: 1,
        type: 'middleBanner'
      }, {
        name: '6连块',
        isShow: 1,
        type: 'sixBatch'
      }, {
        name: '左侧卡片、右侧卡片上、右侧卡片下',
        isShow: 1,
        type: 'threeBatch'
      }],
      tableDataFour: [{
        name: '商品列表 TAB底色',
        type: 'tbBg',
        color: ''
      }, {
        name: '字体色值',
        type: 'textColor',
        color: ''
      }, {
        name: '返回顶部图标',
        type: 'goTop',
        url: '',
        size: '500*600'
      }, {
        name: '足迹图标',
        type: 'footIcon',
        url: '',
        size: '500*600'
      }],
      tableDataFif: [{
        name: '首页',
        size: '120*120',
        type: 'home',
        selectUrl: '',
        normalUrl: ''
      }, {
        name: '本地',
        size: '120*120',
        type: 'local',
        selectUrl: '',
        normalUrl: ''
      }, {
        name: '排行榜',
        size: '120*120',
        type: 'rank',
        selectUrl: '',
        normalUrl: ''
      }, {
        name: '发圈',
        size: '120*120',
        type: 'hair',
        selectUrl: '',
        normalUrl: ''
      }, {
        name: '我的',
        size: '120*120',
        type: 'mine',
        selectUrl: '',
        normalUrl: ''
      }]
    };
  },
  computed: {
    homeTopList: function homeTopList() {
      return this.tableData;
    },
    homeTopSecondList: function homeTopSecondList() {
      return this.tableDataTwo;
    },
    homeMiddleList: function homeMiddleList() {
      return this.tableDataThree;
    },
    homeFootList: function homeFootList() {
      return this.tableDataFour;
    },
    tabBarList: function tabBarList() {
      return this.tableDataFif;
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (this.appId > 0) {
      this.getList();
    }
    setTimeout(function () {
      _this.dataBuff();
    }, 500);
  },
  methods: {
    getList: function getList() {
      var _this2 = this;
      var obj = {
        1: this.tableData,
        2: this.tableDataTwo,
        3: this.tableDataThree,
        4: this.tableDataFour,
        5: this.tableDataFif
      };
      var arr = [];
      for (var i in obj) {
        arr.push("home_".concat(i));
      }
      (0, _creatApp.getConfigList)({
        appId: this.appId,
        itemKeyList: arr
      }).then(function (res) {
        res.data.map(function (i) {
          switch (i.itemKey) {
            case 'home_1':
              _this2.tableData = JSON.parse(i.itemValue);
              break;
            case 'home_2':
              _this2.tableDataTwo = JSON.parse(i.itemValue);
              break;
            case 'home_3':
              _this2.tableDataThree = JSON.parse(i.itemValue);
              break;
            case 'home_4':
              _this2.tableDataFour = JSON.parse(i.itemValue);
              break;
            case 'home_5':
              _this2.tableDataFif = JSON.parse(i.itemValue);
              break;
            default:
              break;
          }
        });
      });
    },
    save: function save() {
      var _this3 = this;
      var obj = {
        1: this.tableData,
        2: this.tableDataTwo,
        3: this.tableDataThree,
        4: this.tableDataFour,
        5: this.tableDataFif
      };
      (0, _creatApp.saveSetting)({
        appId: this.appId,
        itemKey: "home_".concat(this.activeNum),
        itemValue: JSON.stringify(obj[this.activeNum])
      }).then(function (res) {
        _this3.$notify.success({
          title: '温馨提示',
          message: '操作成功'
        });
      });
    },
    handleChildData: function handleChildData(val) {
      this.activeNum = val;
    },
    dataBuff: function dataBuff() {
      // 确保第一次进来可以刷新子组件
      this.tableData.splice(0, 0);
      this.tableDataTwo.splice(0, 0);
      this.tableDataThree.splice(0, 0);
      this.tableDataFour.splice(0, 0);
      this.tableDataFif.splice(0, 0);
    },
    // before(file, val, text) {
    //   console.log(text, '哈哈哈哈哈')
    //   // 将File对象转换为Blob
    //   const blob = new Blob([file], { type: file.type })
    //   // 使用Blob对象，例如创建一个URL
    //   const blobUrl = URL.createObjectURL(blob)
    //   if (text) {
    //     val[text] = blobUrl
    //   } else {
    //     val.url = blobUrl
    //   }
    // },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref, val, text) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              if (text) {
                val[text] = pictureUrl;
              } else {
                val.url = pictureUrl;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      function handleFileUpload(_x, _x2, _x3) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    del: function del(val, text) {
      var _this4 = this;
      this.$confirm('是否确认要删除该图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.$notify.success({
          title: '温馨提示',
          message: '操作成功'
        });
        if (text) {
          val[text] = '';
        } else {
          val.url = '';
        }
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
};